import { render, staticRenderFns } from "./product-sale.vue?vue&type=template&id=287ed056&scoped=true"
import script from "./product-sale.vue?vue&type=script&lang=ts"
export * from "./product-sale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287ed056",
  null
  
)

export default component.exports